export const SOFTLINE_API_USER_CONTACT = '/v1/security/user/contact';
export const SOFTLINE_API_USER_CONTACT_DEFINITION =
  '/v1/security/user/contact/definition';
